import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatSelect } from '@angular/material/select';

// Material draws select and autocomplete menus inline. Inside a dialog or a
// scrolling table that menu is clipped or hidden. Attach every one to the
// page overlay so it opens on top, on pages and in dialogs.

type SelectHost = {
  ngOnInit?: () => void;
  _popoverLocation: string | null;
};

const selectProto = MatSelect.prototype as unknown as SelectHost;
const originalSelectInit = selectProto.ngOnInit;
selectProto.ngOnInit = function (this: SelectHost): void {
  this._popoverLocation = 'global';
  originalSelectInit?.call(this);
};

type PositionStrategy = {
  withPopoverLocation: (location: string) => PositionStrategy;
};

const autocompleteTriggerProto = MatAutocompleteTrigger.prototype as unknown as {
  _getOverlayPosition: () => PositionStrategy;
};
const originalAutocompletePosition = autocompleteTriggerProto._getOverlayPosition;
autocompleteTriggerProto._getOverlayPosition = function (this: MatAutocompleteTrigger): PositionStrategy {
  return originalAutocompletePosition.call(this).withPopoverLocation('global');
};
